import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import store from 'Redux/store';

export default function TrackedLink({ to, type, section, children, ...props }) {
  const onClick = () => {
    store.dispatch({
      type,
      payload: { section, value: to },
    });
  };

  return (
    <Link to={to} onClick={onClick} {...props}>
      {children}
    </Link>
  );
}

TrackedLink.propTypes = {
  to: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
